/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {
    Button,
    Card,
    CardImg,
    CardSubtitle,
    CardTitle,
    Col,
    Collapse,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    UncontrolledTooltip
} from 'reactstrap';
// core components
import ContentService from "../services/xgContentService";
import _ from "lodash";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import Paginations from "./Paginations";
import FormReactSelect from "../components/common/form/FormReactSelect";
import {contentType} from "../util/contentType";
import {contentCategory} from "../util/contentCategory";
import {isMobile} from "react-device-detect";
import AppNavBar from "./AppNavBar";
import NotificationAlert from "react-notification-alert";
import SecurityService from "../services/securityService";
import isTrainingSession from "./pages/util/isTrainingSession";
import {subscriptionType} from "../util/subscriptionType";
import {contentArticleType} from "../util/contentArticleType";

class KnowledgeCentre2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            term: "",
            collapseSearchServices: false,
            collapseSearchArticles: false,
            completeContentList: [],
            searchList: [],
            articleKey: UtilService.uuidv4(),
            videoKey: UtilService.uuidv4(),
            audioKey: UtilService.uuidv4(),
            loginModal: false,
            currentPage: 1,
            pageSize: 9, // 8 items to display 4 per row (2 rows per page)
            selectedContentType: {key: "ALL", value: "ALL"},
            selectedCategory: {key: "ALL", value: "ALL"},
            selectedSubCategory: {key: "ALL", value: "ALL"},
            selectedSubscriptionType: {key: "ALL", value: "ALL"},
        };
        this.filterByContentType = this.filterByContentType.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    trimmedTitle = (title) => {
        if (!title) return '';

        if (title.length > 60) {
            return title.substring(0, 60) + '...';
        }

        // Add non-breaking spaces (&nbsp;) to make it exactly 60 characters
        return title + '\u00A0'.repeat(60 - title.length);
    };

    displayPaidBasedOnRole = () => {
        let allowedRoles = ["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]
        // Get the roles from localStorage and parse them into an array
        const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
        // Check if any of the allowedRoles are present in storedRoles
        const hasRole = allowedRoles.some(role => storedRoles.includes(role));
        return hasRole ? "none" : "visible";
    }


    icon = (item) => {
        let icon;
        switch (item.contentType) {
            case 'TEXT':
                icon = "fa fa-file-alt";
                break;
            case 'VIDEO':
                icon = "fa fa-video";
                break;
            case 'AUDIO':
                icon = "fa fa-headphones";
                break;
            default:
                icon = "fa fa-file-alt"; // Default icon if type is unknown
        }
        return icon;
    }

    componentDidMount() {
        ContentService.list().then((response) => {
            console.log(response);
            this.setState({completeContentList: response});
            this.setState({searchList: response});
            this.setState({audio: this.filterByContentType(this.state.completeContentList, "AUDIO")});
            this.setState({video: this.filterByContentType(this.state.completeContentList, "VIDEO")});
            this.setState({text: this.filterByContentType(this.state.completeContentList, "TEXT")});
            this.toggleSearchArticles();
            this.setState({
                articleKey: UtilService.uuidv4(),
                videoKey: UtilService.uuidv4(),
                audioKey: UtilService.uuidv4(),
            })
        });
    }

    onPageChange(pageNumber) {
        this.setState({currentPage: pageNumber});
    }

    renderCards(items) {
        return (
            <Row className="justify-content-center">
                {items.map((item) => (
                    <Col
                        xs="12" // Full width on extra small screens
                        sm="6"  // Half width on small screens
                        md="4"  // Third width on medium screens
                        lg="4"  // Quarter width on large screens
                        key={UtilService.uuidv4()}
                        className="mb-4"
                    >
                            <Card style={{position: "relative", height: "100%", transition: "transform 0.2s",}}
                              onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = "scale(1.1)";
                              }}
                              onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                              }}
                        >
                            {/* Card Image */}
                            <CardImg
                                style={{
                                    width: '100%',
                                    height: '200px',
                                    objectFit: 'cover',
                                }}
                                src={require("assets/img/brand/knowledge.jpeg")}
                                alt="Card image cap"
                            />

                            {/* Icon Overlay */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    // backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    borderRadius: "50%",
                                    padding: "5px",
                                    color: "white",
                                    fontSize: "1.2rem",
                                }}
                            >
                                {item?.isPaidContent && (
                                    <span className="paid-badge"
                                          style={{display: this.displayPaidBasedOnRole()}}>Paid</span>
                                )}
                                {isTrainingSession(item) && (
                                    <span className="training-badge">Training</span>
                                )}
                                <span className={this.icon(item)}/>
                            </div>

                            {/* Card Footer Content */}
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "0",
                                    width: "100%",
                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                    color: "white",
                                    padding: "10px",
                                    textAlign: "justify",
                                }}
                            >
                                <CardTitle
                                    onClick={(e) => this.viewContent(e, item)}
                                    style={{
                                        cursor: "pointer",
                                        fontSize: "1.2rem",
                                        fontWeight: "bold",
                                    }}

                                    data-placement="bottom"
                                    id={"tooltip" + item.uniqueId}
                                >
                                    {this.trimmedTitle(item.title)}
                                </CardTitle>
                                <UncontrolledTooltip
                                    delay={0}
                                    placement="bottom"
                                    target={"tooltip" + item.uniqueId}
                                >
                                    {item.title}
                                </UncontrolledTooltip>
                                <CardSubtitle style={{fontSize: "0.75rem"}}>
                                    {item.category}
                                </CardSubtitle>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    }


    viewContent(e, item) {
        e.preventDefault();
        if (isTrainingSession(item)) {
            if (localStorage.getItem("userId") && SecurityService.hasAnyRole(["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN",
                "ROLE_LEVEL2", "ROLE_LEVEL3", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])) {
                this.props.history.push(`/blog/${item.slug}`);
            } else {
                this.notify("danger", "Subscription Required", "This content is available only to plan Advance and above. Please upgrade your plan to continue.")
            }
        } else if (item?.isPaidContent === true) {
            if (localStorage.getItem("userId") && SecurityService.hasAnyRole(["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN", "ROLE_LEVEL2", "ROLE_LEVEL3",
                "ROLE_STARTER", "ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"])) {
                this.props.history.push(`/blog/${item.slug}`);
            } else {
                this.notify("danger", "Subscription Required", "This content is available only to subscribers. Please upgrade your plan to continue.")
            }
        } else if (item?.isPaidContent === false || !isTrainingSession(item)) {
            this.props.history.push(`/blog/${item.slug}`);
        }

    }

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    filterByContentType = (data, type) => {
        return _.filter(data, {contentType: type});
    };

    filterBySubscriptionType = (data, type) => {
        console.log("filterBySubscriptionType - ", type);
        if (type === "FREE") {
            return _.filter(data, content => content?.isPaidContent === false && !isTrainingSession(content));
        } else if (type === "PAID") {
            return _.filter(data, content => content?.isPaidContent === true || isTrainingSession(content));
        } else if (type === "TRAINING") {
            return _.filter(data, content => isTrainingSession(content));
        } else if (type === "ALL") {
        }
        return data;
    }

    filterByCategory = (data, type) => {
        return _.filter(data, {category: type});
    };

    filterBySubCategory = (data, type) => {
        console.log(type);
        const filteredList = _.filter(data, (item) => _.includes(item.articleTypes, type));
        console.log("Filtered by subcategory : ", filteredList)
        return filteredList;
    };

    toggleSearchServices = (event) => {
        event.preventDefault();
        this.props.history.push("/");
    }

    toggleSearchReviews = (event) => {
        event.preventDefault();
        this.props.history.push("/xareview");
    }

    toggleSearchArticles = () => {
        this.setState({
            collapseSearchArticles: !this.state.collapseSearchArticles,
            collapseSearchServices: false // Close the services section when articles is toggled
        });
    }

    displaySearchArticles = () => {
        return this.state.searchList.length === 0 ? "Display Search Articles" : <></>
    }

    onSearchInputChange = (event) => {
        let term = event.target.value;
        this.setState({term: event.target.value})
        console.log(this.state.term)
    }

    onSearch = event => {
        const filteredItems = _.filter(this.state.completeContentList, (item) => {
            return _.includes(item.title.toLowerCase(), this.state.term.toLowerCase()) ||
                _.includes(item.category.toLowerCase(), this.state.term.toLowerCase()) ||
                _.includes(item.content.toLowerCase(), this.state.term.toLowerCase());
        });
        console.log(filteredItems)
        this.setState({audio: this.filterByContentType(filteredItems, "AUDIO")});
        this.setState({searchList: filteredItems});
        this.setState({video: this.filterByContentType(filteredItems, "VIDEO")});
        this.setState({text: this.filterByContentType(filteredItems, "TEXT")});
        this.setState({
            articleKey: UtilService.uuidv4(),
            videoKey: UtilService.uuidv4(),
            audioKey: UtilService.uuidv4(),
        })
    }

    handleContentTypeChange = (valueObj, event) => {
        this.clearFilters();
        if (_.isNull(valueObj)) {
            this.setState({selectedContentType: [], contentType: ""});
        } else {
            this.setState({selectedContentType: valueObj, contentType: valueObj.key});
            if (valueObj.key === "TEXT") {
                this.setState({searchList: this.filterByContentType(this.state.completeContentList, "TEXT")});
            } else if (valueObj.key === "AUDIO") {
                this.setState({searchList: this.filterByContentType(this.state.completeContentList, "AUDIO")});
            } else if (valueObj.key === "VIDEO") {
                this.setState({searchList: this.filterByContentType(this.state.completeContentList, "VIDEO")});
            } else {
                this.setState({searchList: this.state.completeContentList});
            }
        }
    };

    handleSubscriptionTypeChange = (valueObj, event) => {
        this.clearFilters();
        if (_.isNull(valueObj)) {
            this.setState({selectedContentType: [], contentType: ""});
        } else {
            this.setState({selectedSubscriptionType: valueObj, contentType: valueObj.key});
            if (valueObj.key === "FREE") {
                this.setState({searchList: this.filterBySubscriptionType(this.state.completeContentList, "FREE")});
            } else if (valueObj.key === "PAID") {
                this.setState({searchList: this.filterBySubscriptionType(this.state.completeContentList, "PAID")});
            } else if (valueObj.key === "TRAINING") {
                this.setState({searchList: this.filterBySubscriptionType(this.state.completeContentList, "TRAINING")});
            } else {
                this.setState({searchList: this.state.completeContentList});
            }
        }
    };


    handleCategoryChange = (valueObj, event) => {
        this.clearFilters()
        if (_.isNull(valueObj)) {
            this.setState({selectedCategory: [], category: ""});
        } else {
            this.setState({selectedCategory: valueObj, category: valueObj.key});
            if (valueObj.key === "INTERNATIONAL_EXPANSION") {
                this.setState({searchList: this.filterByCategory(this.state.completeContentList, "INTERNATIONAL_EXPANSION")});
            } else if (valueObj.key === "PRODUCTIVITY_IMPROVEMENTS") {
                this.setState({searchList: this.filterByCategory(this.state.completeContentList, "PRODUCTIVITY_IMPROVEMENTS")});
            } else if (valueObj.key === "SALES_EFFECTIVENESS") {
                this.setState({searchList: this.filterByCategory(this.state.completeContentList, "SALES_EFFECTIVENESS")});
            } else if (valueObj.key === "GLOBAL_SOURCING") {
                this.setState({searchList: this.filterByCategory(this.state.completeContentList, "GLOBAL_SOURCING")});
            } else {
                this.setState({searchList: this.state.completeContentList});
            }
        }
    };

    clearFilters = () => {
        this.setState({selectedContentType: {key: "ALL", value: "ALL"}});
        this.setState({selectedCategory: {key: "ALL", value: "ALL"}});
        this.setState({selectedSubCategory: {key: "ALL", value: "ALL"}});
        this.setState({selectedSubscriptionType: {key: "ALL", value: "ALL"}});
    }

    handleSubCategoryChange = (valueObj, event) => {
        this.clearFilters();
        if (_.isNull(valueObj) || valueObj.key === "ALL") {
            this.setState({searchList: this.state.completeContentList});
        } else {
            this.setState({selectedSubCategory: valueObj, subCategory: valueObj.key});
            this.setState({searchList: this.filterBySubCategory(this.state.completeContentList, valueObj.key)});
        }
    };

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };


    render() {
        const {completeContentList, currentPage, pageSize, searchList} = this.state;
        const startIndex = (currentPage - 1) * pageSize;
        const paginatedItems = searchList.slice(startIndex, startIndex + pageSize);

        return (
            <div>
                {/*Nav Bar*/}
                <AppNavBar loginModalToggle={this.toggleModal}/>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>International Expansion </p>
                                    <h1 style={{textAlign: "start"}}>Learn | Grow | Share</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>
                {/* Collapsible Sections */}
                <Container className={"mt-10"}
                           style={{
                               border: "2px solid #4E5F7A",
                               padding: "1.5rem",
                               borderRadius: "2px",
                               marginTop: "2.5rem", // Adjust to divide the buttons in half
                               position: "relative",
                               zIndex: "1"
                           }}>
                    {/* Search Services */}
                    <div className="text-center" style={{marginTop: "-4rem"}}>
                        <Button color="white" onClick={this.toggleSearchServices} className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%"
                                }}>
                            {isMobile ? "Search" : "Search"}
                        </Button>

                        {/*Xare View*/}
                        <Button color="white" className="mb-3" onClick={this.toggleSearchReviews}
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.4rem"
                                }}>
                            {isMobile ? "Partners" : "Partners"}
                        </Button>
                        {/* Search Articles */}
                        <Button color="default" className="mb-3"
                                style={{
                                    width: "30%",
                                    fontSize: isMobile ? "0.9rem" : "1.5rem",
                                    padding: "1.5%",
                                    marginLeft: "-0.5rem"
                                }}>
                            {isMobile ? "Knowledge" : "Knowledge"}
                        </Button>
                    </div>
                    <Collapse isOpen={this.state.collapseSearchServices}>
                    </Collapse>


                    <Collapse isOpen={this.state.collapseSearchArticles}>
                        <Form onSubmit={(e) => {
                            e.preventDefault()
                            this.onSearch();
                        }}>
                            <FormGroup>
                                <Label for="searchText">Search Article</Label>
                                <Input onChange={this.onSearchInputChange} type="text" name="searchText"
                                       id="searchText"/>
                            </FormGroup>
                            <div className="text-center">
                                <Button color="default" outline onClick={this.onSearch}
                                        type="button">{"Search"}</Button>
                            </div>
                        </Form>
                    </Collapse>
                </Container>
                <br/>
                <br/>
                <br/>
                <Container>
                    <Row>
                        <Col sm={"6"} md={"3"}>
                            <div style={{display: this.displayPaidBasedOnRole()}}>
                                <FormReactSelect
                                    selectKey={UtilService.uuidv4()}
                                    isMulti={false}
                                    className="form-control-label"
                                    isSearchable={true}
                                    label="Filter By Type"
                                    name={"subscriptionType"}
                                    onChange={this.handleSubscriptionTypeChange}
                                    optionValue={"value"}
                                    defaultValue={this.state.selectedSubscriptionType}
                                    optionList={[...subscriptionType, {key: "ALL", value: "All"}]}
                                    optionLabel={"key"}
                                    placeHolder="inputPlaceHolder.content.contentType"
                                    errorMsg={this.errorObj?.contentType || ""}
                                    // required
                                />
                            </div>
                        </Col>
                        <Col sm="6" md={"3"}>
                            <FormReactSelect
                                selectKey={UtilService.uuidv4()}
                                isMulti={false}
                                className="form-control-label"
                                isSearchable={true}
                                label="Filter By Category"
                                name={"category"}
                                onChange={this.handleCategoryChange}
                                optionValue={"value"}
                                defaultValue={this.state.selectedCategory}
                                optionList={[...contentCategory, {key: "ALL", value: "ALL"}]}
                                optionLabel={"key"}
                                placeHolder="inputPlaceHolder.content.contentType"
                                errorMsg={this.errorObj?.category || ""}
                                // required
                            />
                        </Col>
                        <Col sm="6" md={"3"}>
                            <FormReactSelect
                                selectKey={UtilService.uuidv4()}
                                isMulti={false}
                                className="form-control-label"
                                isSearchable={true}
                                label="Filter By Sub Category"
                                name={"category"}
                                onChange={this.handleSubCategoryChange}
                                optionValue={"value"}
                                defaultValue={this.state.selectedSubCategory}
                                optionList={[...contentArticleType, {key: "ALL", value: "ALL"}]}
                                optionLabel={"key"}
                                placeHolder="Sub Category"
                                errorMsg={this.errorObj?.subCategory || ""}
                                // required
                            />
                        </Col>

                        <Col sm="6" md={"3"}>
                            <FormReactSelect
                                selectKey={UtilService.uuidv4()}
                                isMulti={false}
                                className="form-control-label"
                                isSearchable={true}
                                label="Filter By Format"
                                name={"contentType"}
                                onChange={this.handleContentTypeChange}
                                optionValue={"value"}
                                defaultValue={this.state.selectedContentType}
                                optionList={[...contentType, {key: "ALL", value: "ALL"}]}
                                optionLabel={"key"}
                                placeHolder="inputPlaceHolder.content.contentType"
                                errorMsg={this.errorObj?.contentType || ""}
                                // required
                            />
                        </Col>
                    </Row>
                    {this.renderCards(paginatedItems)}
                    <Paginations
                        totalItems={completeContentList.length}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={this.onPageChange}
                    />
                </Container>

                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>
                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default KnowledgeCentre2;
